<h1 mat-dialog-title>詳細</h1>

<div mat-dialog-content>
  <form class="detail-form" #detailForm="ngForm">
    <div class="row">
        <div class="title">対象日：</div><div class="contents">{{date}}</div>
    </div>
    <div class="row">
        <div class="title">理由：</div><div class="contents">{{cause}}</div>
    </div>
    <div class="row">
        <div class="title">状態：</div><div class="contents">{{state}}</div>
    </div>
      <button mat-raised-button (click)="onConfirm()">確認</button>
  </form>

</div>
